import React from 'react';
import classes from './KoshaMsPage.module.css';

import { BasicContainer } from '../../UI/ContentContainer';
import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Box, Typography } from '@mui/material';

import process from '../../../assets/img/kosha_page/process.png';
import consulting_process from '../../../assets/img/kosha_page/consulting_process.png';
import MetaTags from '../../MetaTags/MetaTags';

const KoshaMsPage = () => {
    return (
        <BasicContainer>
            <MetaTags 
                title="KOSHA-MS 인증"
                description="KOSHA-MS 인증에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-KOSHA-MS 인증"
                ogdescription="KOSHA-MS 인증에 대해 소개 합니다."
            />
            <PageTitle title="KOSHA-MS 인증"/>
            <TextContent title="KOSHA-MS">
                <Typography variant="description" component="p">
                    KOSHA-MS 인증은 한국산업안전보건공단(KOSHA)이 제공하는 근로자 
                    건강과 안전을 위한 관리 시스템 표준입니다. 
                    이는 기업이 안전한 작업환경을 구축하고 근로자의 건강을 보호하기 
                    위해 적용되는 표준으로, 안전 관리 시스템의 효과적인 운영을 인증하는 과정입니다.
                </Typography>
            </TextContent>

            <TextContent title="운영체계">
                <Box textAlign="center" paddingTop="2rem">
                    <img src={process} alt="process.png" className={classes.process}/>
                </Box>
            </TextContent>

            <TextContent title="KOSHA-MS인증 절차">
            <Box textAlign="center" paddingTop="2rem">
                    <img src={consulting_process} alt="consulting_process.png" className={classes['consulting_process']}/>
                </Box>
            </TextContent>

        </BasicContainer>

    )
}

export default KoshaMsPage;